function shareList() {
	const shareForm = document.getElementById('share-form');
	const shareFormClose = document.querySelectorAll('.share-form__close');
	const shareToggle = document.querySelector('.share-trigger');

	shareToggle.addEventListener('click', function (el) {
		el.preventDefault();
		shareForm.classList.add('is-open');
	});

	shareFormClose.forEach(function (el) {
		el.addEventListener('click', function () {
			shareForm.classList.remove('is-open');
		});
	});
}

if (document.getElementById('share-form')) {
	shareList();
}
